import { useContext, useState, useEffect, useRef, useCallback } from "react";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { createPortal } from "react-dom";
import { CSS } from "@dnd-kit/utilities";
import { snapCenterToCursor } from "@dnd-kit/modifiers";
import {
  VYLABS_BASE_URL,
  GET_APPLICATION_BY_JOB,
  UPDATE_APPLICATION,
  GET_CANDIDATE_BY_ID,
  UPDATE_CANDIDATE_DETAILS,
  VENDORS_SEARCH,
  GET_VENDOR_DETAILS_BY_ID,
  TENANTS_APPLICATION_STAGES_LIST,
} from "../../helper/url_helper";
import { post, get, put } from "../../helper/Api_helper";
import { DynamicContext } from "../../Context/DynamicContext";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar.js";
import { ConfirmationPopup } from "../../Common/PopupStyles/PopupComponent";
import "./KanbanBoard.css";
import jobIcon from "../../Assets/Images/job-schedule-icon.png";
import VybogTALLoaderAnimation from "../Dynamic-Animations/DynamicAnimations.js";
import SidePopup from "../../Common/SidePopup/SidePopup";
import CandidateDetailsContainer from "../../Common/Candidate-Details-Container/CandidateDetailsContainer";
import SettingsIcon from "../../Assets/Images/mingcute_settings-1-line.svg";
import SettingsDarkIcon from "../../Assets/Images/settings-dark.svg";
import canCardcandidatesAssigned from "../../Assets/Images/candidatesAssigned.png";
import canCardcontactAssigned from "../../Assets/Images/contactAssigned.png";
import canCardemailAssigned from "../../Assets/Images/emailAssigned.png";
import { formatDate, toCapitalize } from "../Common-Function/CommonFunctions";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import locationIcon from "../../Assets/Images/location-icon_blue.svg";
import SkillsIcon from "../../Assets/Images/skills_icon.svg";
import { TENANT_CORE_API_KEY } from "../../Tenant-Config/TenantConfig.js";
import { createSavedViews, getSavedViews, patchSavedViews } from "./BoardSavedViews.js";
import Button from "../Button/Button.js";

function CandidateCard({
  candidate,
  onView,
  isSelectMode,
  onSelect,
  isSelected,
}) {
  const parsedResumeData =
    candidate && candidate.parsed_resume
      ? JSON.parse(candidate.parsed_resume)
      : null;
  const candidateParsed = { ...candidate, parsedResumeData };
  const skills =
    candidateParsed.parsedResumeData?.Skills || candidateParsed.skills;
  const skillsArray =
    typeof skills === "string"
      ? skills
          .split(",")
          .map((skill) => skill.trim())
          .filter((skill) => skill)
      : Array.isArray(skills)
        ? skills
        : [];
  const displayedSkills = skillsArray.slice(0, 2);
  const [showPopup, setShowPopup] = useState(false);
  const iconRef = useRef(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const handleViewClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isSelectMode) {
      onSelect(candidate);
    } else if (onView) {
      onView(candidate, e);
    }
  };
  const handleIconMouseEnter = (e) => {
    e.stopPropagation();
    if (!iconRef.current) {
      setShowPopup(true);
      return;
    }
    const rect = iconRef.current.getBoundingClientRect();
    const popupWidth = 320;
    const popupHeight = 280;
    const GAP_BELOW = 8;
    const GAP_ABOVE = -80;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let left = rect.left + window.scrollX;
    const SIDE_MARGIN = 16;
    if (left + popupWidth > viewportWidth - SIDE_MARGIN) {
      left = viewportWidth - popupWidth - SIDE_MARGIN;
    }
    if (left < SIDE_MARGIN) {
      left = SIDE_MARGIN;
    }
    const wouldFitBelow =
      rect.bottom + window.scrollY + GAP_BELOW + popupHeight <= viewportHeight;
    let top;
    if (wouldFitBelow) {
      top = rect.bottom + window.scrollY + GAP_BELOW;
    } else {
      top = rect.top + window.scrollY - popupHeight - GAP_ABOVE;
    }
    const TOP_MARGIN = 16;
    if (top < TOP_MARGIN) top = TOP_MARGIN;
    setPopupPosition({ top, left });
    setShowPopup(true);
  };

  const handleIconMouseLeave = (e) => {
    e.stopPropagation();
    setShowPopup(false);
  };

  return (
    <div
      className="cardc"
      onClick={handleViewClick}
      onMouseEnter={handleIconMouseEnter}
      onMouseLeave={handleIconMouseLeave}
      ref={iconRef}
    >
      <div className="tile-header-container">
        <div className="tile-header">
          <div
            className="tile-header-user"
            style={{ display: "flex", alignItems: "center" }}
          >
            {isSelectMode && (
              <div style={{ marginRight: "10px", zIndex: 2 }}>
                {isSelected ? (
                  <CheckBoxIcon style={{ color: "#6860ee" }} />
                ) : (
                  <CheckBoxOutlineBlankIcon
                    style={{ color: "var(--header__color)" }}
                  />
                )}
              </div>
            )}
            <div className="tile-header-text-container">
              <div className="tile-header-text">
                <span>{candidateParsed.name}</span>
                <div
                  className="tile-subheader"
                  style={{
                    position: "relative",
                    cursor: isSelectMode ? "pointer" : "default",
                  }}
                >
                  {showPopup &&
                    createPortal(
                      <div
                        className="hover-details-popup"
                        style={{
                          position: "fixed",
                          top: `${popupPosition.top}px`,
                          left: `${popupPosition.left}px`,
                          zIndex: 99999,
                          background: "var(--body__background, #fff)",
                          color: "var(--header__color, #333)",
                          border: "1px solid var(--border__color, #e2e8f0)",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                          padding: "12px",
                          minWidth: "300px",
                          fontSize: "13px",
                          pointerEvents: "none",
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={() => setShowPopup(true)}
                        onMouseLeave={() => setShowPopup(false)}
                      >
                        <div>
                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={canCardcandidatesAssigned}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Name</div>
                            </div>
                            <div>{candidateParsed.name || "N/A"}</div>
                          </div>

                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={canCardemailAssigned}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Email</div>
                            </div>
                            <div>{candidateParsed.email || "N/A"}</div>
                          </div>

                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={canCardcontactAssigned}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Contact No.</div>
                            </div>
                            <div>{candidateParsed.phone || "N/A"}</div>
                          </div>

                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={jobIcon}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Experience</div>
                            </div>
                            <div>
                              {candidateParsed.parsedResumeData?.BasicInfo
                                ?.YearsOfExperience || "N/A"}
                            </div>
                          </div>

                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={locationIcon}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Location</div>
                            </div>
                            <div>
                              {[
                                candidateParsed.city,
                                candidateParsed.state,
                                candidateParsed.country,
                              ]
                                .filter((v) => v && v !== "N/A")
                                .join(", ") || "N/A"}
                            </div>
                          </div>

                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={SkillsIcon}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Created</div>
                            </div>
                            <div>
                              {formatDate(candidateParsed.created_at) || "N/A"}
                            </div>
                          </div>

                          <div className="calendar-section-wrapper">
                            <div className="section-title-wrapper">
                              <img
                                alt="calendar"
                                src={SkillsIcon}
                                className="calendar-icon"
                                style={{ width: 15, height: 15 }}
                              />
                              <div>Updated</div>
                            </div>
                            <div>
                              {formatDate(candidateParsed.updated_at) || "N/A"}
                            </div>
                          </div>

                          {displayedSkills.length > 0 && (
                            <div className="calendar-section-wrapper">
                              <div className="section-title-wrapper">
                                <img
                                  alt="calendar"
                                  src={SkillsIcon}
                                  className="calendar-icon"
                                  style={{ width: 15, height: 15 }}
                                />
                                <div>Skills</div>
                              </div>
                              <div
                                className="skills-text"
                                style={{ marginTop: "5px" }}
                              >
                                {displayedSkills.map((skill, index) => (
                                  <div key={index}>
                                    <span
                                      className="skill-badge"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {skill}
                                    </span>
                                  </div>
                                ))}
                                {skillsArray.length > 3 && (
                                  <div className="card-skills-div">
                                    <span
                                      className="skill-badge"
                                      style={{ fontSize: "12px" }}
                                    >
                                      +{skillsArray.length - 3}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>,
                      document.body,
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SortableItem({
  id,
  candidate,
  columnKey,
  onView,
  isSelectMode,
  onSelectCandidate,
  selectedCandidates,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });
  const getBorderClass = () => {
    return "kanbanboard-border";
  };

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || "transform 200ms ease, opacity 200ms ease",
    opacity: isDragging ? 0.3 : 1,
    background: "var(--body__background)",
    borderRadius: "20px",
    marginBottom: "8px",
    zIndex: isDragging ? 999 : 1,
    boxShadow: isDragging
      ? "0 5px 15px rgba(0,0,0,0.15)"
      : "0 1px 3px rgba(0,0,0,0.1)",
    transformOrigin: "50% 50%",
    cursor: isDragging ? "grabbing" : "grab",
    position: "relative",
  };

  const isInterestedColumn = columnKey !== "";
  const showCheckbox = isSelectMode && isInterestedColumn;
  const isSelected =
    showCheckbox &&
    selectedCandidates.some((c) => String(c.id) === String(candidate.id));

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div
        className={
          candidate.length === 0 ? "" : `candidate-card ${getBorderClass()}`
        }
      >
        {candidate.length === 0 ? (
          <div key={id}></div>
        ) : (
          <CandidateCard
            key={id}
            candidate={candidate}
            onClick={() => {}}
            onView={onView}
            isSelectMode={showCheckbox}
            onSelect={onSelectCandidate}
            isSelected={isSelected}
          />
        )}
      </div>
    </div>
  );
}

function KanbanBoard({
  jobId,
  onTotalCount,
  applications,
  counts,
  onRefresh,
  isSelectMode,
  selectedCandidates,
  onSelectCandidate,
}) {
  const { userDetails, setIsFromJobRecommendedCandidates, isDarkMode } =
    useContext(DynamicContext);
  const [vendorList, setVendorList] = useState([]);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [isAllCandidatesActive, setIsAllCandidatesActive] = useState(true);
  const [allCanList, setAllCanList] = useState([]);
  const [myCanList, setMyCanList] = useState([]);
  const [totalAssignedCandidates, setTotalAssignedCandidates] = useState(0);
  const [stageCounts, setStageCounts] = useState({});
  const [callStages, setCallStages] = useState([]);
  const [savedCallStages, setSavedCallStages] = useState([]);
  const [allSavedStages, setAllSavedStages] = useState([]);

  const topScrollRef = useRef(null);
  const bottomScrollRef = useRef(null);
  const dropdownRef = useRef(null);
  const dropdownBtnRef = useRef(null);
  const popupTimeoutRef = useRef();

  useEffect(() => {
    const top = topScrollRef.current;
    const bottom = bottomScrollRef.current;

    if (top && bottom) {
      const syncScroll = () => {
        top.scrollLeft = bottom.scrollLeft;
      };
      const syncReverse = () => {
        bottom.scrollLeft = top.scrollLeft;
      };

      top.addEventListener("scroll", syncReverse);
      bottom.addEventListener("scroll", syncScroll);

      return () => {
        top.removeEventListener("scroll", syncReverse);
        bottom.removeEventListener("scroll", syncScroll);
      };
    }
  }, []);

  const [tasks, setTasks] = useState([]);
  const [columns, setColumns] = useState({});
  const [columnsForCustomize, setColumnsForCustomize] = useState({});
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [kanbanBoardWidth, setKanbanBoardWidth] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
  );

  const stageOrder = savedCallStages.length !== 0 ?
   savedCallStages.map((stage) => stage.system_key) :
   callStages.map((stage) => stage.system_key);

  const [updatedStage, setUpdatedStage] = useState("");
  const [selectedJobID, setSelectedJobID] = useState(jobId);
  const [activeId, setActiveId] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [dragData, setDragData] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isCandidateDetailsOpen, setIsCandidateDetailsOpen] = useState(false);
  const [candidateDetailsLoading, setCandidateDetailsLoading] = useState(false);
  const [candidateDetailsError, setCandidateDetailsError] = useState("");
  const [activeTab, setActiveTab] = useState(0);

  const columnWidth = 320;
  const totalWidth = kanbanBoardWidth.length * columnWidth;

  const getColumnCountClass = (columnKey) => {
    const normalizedKey = columnKey.toLowerCase().trim();

    if (normalizedKey.includes("new profile")) {
      return "new-profile";
    } else if (normalizedKey.includes("not spoken")) {
      return "not-spoken";
    } else if (normalizedKey.includes("spoken")) {
      return "spoken";
    } else if (normalizedKey.includes("not suitable")) {
      return "not-suitable";
    } else if (normalizedKey.includes("not interested")) {
      return "not-interested";
    } else if (normalizedKey.includes("interested")) {
      return "interested";
    } else if (normalizedKey.includes("proposed")) {
      return "proposed";
    } else if (normalizedKey.includes("shortlisted")) {
      return "shortlisted";
    } else if (normalizedKey.includes("interview scheduled")) {
      return "interview";
    } else if (normalizedKey.includes("interview reject")) {
      return "interview-reject";
    } else if (normalizedKey.includes("offered")) {
      return "offered";
    } else if (normalizedKey.includes("offer rejected - client")) {
      return "offer-rejected-client";
    } else if (normalizedKey.includes("offer declined - candidate")) {
      return "offer-declined-candidate";
    } else if (normalizedKey.includes("joined")) {
      return "joined";
    } else if (normalizedKey.includes("joined - client reject")) {
      return "joined-client-reject";
    } else if (normalizedKey.includes("project end")) {
      return "project-end";
    } else if (normalizedKey.includes("fake")) {
      return "fake";
    } else if (normalizedKey.includes("withdrawn")) {
      return "withdrawn";
    } else {
      return "new-profile";
    }
  };

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = async (event) => {
    const columns = document.querySelectorAll(".kanban-column");
    columns.forEach((column) => {
      column.classList.remove("column-highlight");
    });

    setActiveId(null);
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const fromColumn = Object.keys(tasks).find((col) =>
      (tasks[col] || []).filter(Boolean).includes(active.id),
    );

    let toColumn;
    toColumn = stageOrder.find((stage) =>
      (tasks[stage] || []).includes(over.id),
    );

    if (!toColumn && over.id && typeof over.id === "string") {
      if (tasks[over.id]) {
        toColumn = over.id;
      }
    }

    if (fromColumn && toColumn && fromColumn !== toColumn) {
      const newFrom = tasks[fromColumn].filter((id) => id !== active.id);
      const newTo = [...(tasks[toColumn] || []), active.id];
      setTasks({
        ...tasks,
        [fromColumn]: newFrom,
        [toColumn]: newTo,
      });
      setDragData({
        active,
        fromColumn,
        toColumn,
      });
      if (popupTimeoutRef.current) clearTimeout(popupTimeoutRef.current);
      popupTimeoutRef.current = setTimeout(() => {
        setConfirmationOpen(true);
      }, 250);
    } else if (fromColumn === toColumn) {
      const oldIndex = tasks[fromColumn].indexOf(active.id);
      const newIndex = tasks[toColumn].indexOf(over.id);
      const newTasks = {
        ...tasks,
        [fromColumn]: arrayMove(tasks[fromColumn], oldIndex, newIndex),
      };
      setTasks(newTasks);
    }
  };

  useEffect(() => {
    return () => {
      if (popupTimeoutRef.current) clearTimeout(popupTimeoutRef.current);
    };
  }, []);

  const handleConfirmStageChange = async () => {
    if (popupTimeoutRef.current) clearTimeout(popupTimeoutRef.current);
    if (!dragData) return;

    const { active, toColumn } = dragData;

    const payload = {
      assignedRecruiterID: userDetails?.id,
      id: active.id.appId,
      remarks: columns[toColumn] || toColumn,
      stage: toColumn,
    };

    try {
      await put(VYLABS_BASE_URL, UPDATE_APPLICATION, payload);
      if (onRefresh) {
        onRefresh();
      } else {
        setUpdatedStage(toColumn);
      }
      Toast("success", "Candidate stage updated successfully");
    } catch (error) {
      console.error("Error updating candidate stage:", error);
      Toast("error", "Failed to update candidate stage");
    }

    setConfirmationOpen(false);
    setDragData(null);
  };

  const handleCancelStageChange = () => {
    if (popupTimeoutRef.current) clearTimeout(popupTimeoutRef.current);
    if (dragData) {
      const { active, fromColumn, toColumn } = dragData;
      const newTo = tasks[toColumn].filter((id) => id !== active.id);
      const newFrom = [...(tasks[fromColumn] || []), active.id];
      setTasks({
        ...tasks,
        [fromColumn]: newFrom,
        [toColumn]: newTo,
      });
    }
    setConfirmationOpen(false);
    setDragData(null);
  };

  const groupByStage = (data) => {
    const grouped = {};
    const seenCandidates = new Set();
    stageOrder.forEach((systemKey) => {
      grouped[systemKey] = [];
    });

    if (!data || !Array.isArray(data)) {
      return grouped;
    }

    data.forEach((item) => {
      const stageKey = item.stage;
      const appId = item.id;
      const candidate = item.candidate || {};

      if (!appId || seenCandidates.has(appId)) return;
      if (!grouped[stageKey]) return;

      grouped[stageKey].push({
        appId,
        ...candidate,
        id: item.candidate_id,
      });
      seenCandidates.add(appId);
    });

    return grouped;
  };

  const createColumnsFromStages = () => {
    const data = savedCallStages.length === 0 ? callStages : savedCallStages;
    return data.reduce((acc, stage) => {
      acc[stage.system_key] = stage.name;
      return acc;
    }, {});
  };

  const createColumnsForCustomizeStages = () => {
    return callStages.reduce((acc, stage) => {
      acc[stage.system_key] = stage.name;
      return acc;
    }, {});
  }

  const fetchCandidatesByStage = async () => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_APPLICATION_BY_JOB}?job_id=${selectedJobID}`,
      );

      const applications = response?.applications || [];
      const stages_count = response?.stages_count || [];
      const newStageCounts = {};

      stages_count.forEach((item) => {
        newStageCounts[item.stage] = item.count;
      });

      setStageCounts(newStageCounts);

      const totalAssignedCandidates =
        stages_count.reduce((sum, obj) => sum + obj.count, 0) || 0;
      setTotalAssignedCandidates(totalAssignedCandidates);
      const dynamicColumns = createColumnsFromStages();
      const customizeDynamicColumns = createColumnsForCustomizeStages();
      setColumns(dynamicColumns);
      setColumnsForCustomize(customizeDynamicColumns);
      setTasks(groupByStage(applications));
    } catch (err) {
      console.error("GET JOBS_LIST error:", err);
    }
  };
  useEffect(() => {
    if (onTotalCount) {
      onTotalCount(totalAssignedCandidates);
    }
  }, [totalAssignedCandidates, onTotalCount]);

  useEffect(() => {
    if (callStages.length === 0) return;

    if (applications && counts) {
      setStageCounts(counts);
      const totalAssignedCandidates =
        Object.values(counts).reduce((sum, count) => sum + count, 0) || 0;
      setTotalAssignedCandidates(totalAssignedCandidates);

      const dynamicColumns = createColumnsFromStages();
      const customizeDynamicColumns = createColumnsForCustomizeStages();
      setColumns(dynamicColumns);
      setColumnsForCustomize(customizeDynamicColumns);
      setTasks(groupByStage(applications));
    } else {
      fetchCandidatesByStage();
    }
  }, [updatedStage, selectedJobID, applications, counts, callStages, savedCallStages]);

  useEffect(() => {
    setVisibleColumns(Object.keys(columns));
    setKanbanBoardWidth(Object.keys(columns));
  }, [columns]);

  const toggleColumnVisibility = (columnKey) => {
    setVisibleColumns((prev) => {
      if (prev.includes(columnKey)) {
        return prev.filter((key) => key !== columnKey);
      } else {
        return [...prev, columnKey];
      }
    });
  };

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleSelectAll = () => {
    setVisibleColumns(Object.keys(columnsForCustomize));
  };

  const handleSelectNone = () => {
    setVisibleColumns([]);
  };

  const onCandidateClick = (candidate) => {
    setActiveTab(0);
    handleCardView(candidate);
  };

  const isCandidateSelected = (candidate) =>
    selectedCandidates?.some(
      (selected) => String(selected.id) === String(candidate.id),
    );

  const isStageSelected = (stageKey) => {
    const stageCandidates = (tasks[stageKey] || []).filter(Boolean);

    return (
      stageCandidates.length > 0 &&
      stageCandidates.every((candidate) => isCandidateSelected(candidate))
    );
  };

  const toggleStageSelection = (stageKey) => {
    if (!isSelectMode) return;

    const stageCandidates = (tasks[stageKey] || []).filter(Boolean);
    if (stageCandidates.length === 0) return;

    const allSelected = stageCandidates.every((candidate) =>
      isCandidateSelected(candidate),
    );

    stageCandidates.forEach((candidate) => {
      const selected = isCandidateSelected(candidate);

      if ((allSelected && selected) || (!allSelected && !selected)) {
        onSelectCandidate(candidate);
      }
    });
  };

  const fetchCandidateById = useCallback(async (id) => {
    try {
      const res = await get(VYLABS_BASE_URL, `${GET_CANDIDATE_BY_ID}?id=${id}`);
      const candidate = res?.candidate;
      const candidatefiles = res?.files;
      const parsedResumeData = candidate?.parsed_resume
        ? JSON.parse(candidate.parsed_resume)
        : null;
      const presignedUrl =
        candidatefiles && candidatefiles.length > 0
          ? candidatefiles[0].presigned_url
          : null;
      const updatedCandidate = {
        ...candidate,
        secondaryEmail: candidate.secondary_email,
        secondaryPhone: candidate.secondary_phone,
        vendorID: candidate.vendor_id,
        lineAddress1: candidate.line_address_1,
        lineAddress2: candidate.line_address_2,
        preferredSalary: candidate.preferred_salary,
        zipCode: candidate.zip_code,
        parsedResumeData,
        files: candidatefiles || null,
        presignedUrl,
        isFileBased: false,
        avatar: res?.profile_img_url,
      };
      if (updatedCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendorID}`
          );
          setAssignedVendor(vendorResponse);
          updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          updatedCandidate.vendorDetails = null;
          setAssignedVendor(null);
        }
      } else {
        updatedCandidate.vendorDetails = null;
        setAssignedVendor(null);
      }
      setSelectedCandidate(updatedCandidate);
      return updatedCandidate;
    } catch (error) {
      console.error("Error fetching candidate:", error);
      Toast("error", error.response.data || "Failed to fetch candidate details");
    }
  }, []);

  useEffect(() => {
    return () => {
      setIsFromJobRecommendedCandidates(false);
    };
  }, [setIsFromJobRecommendedCandidates]);

  const handleCardView = async (candidate, event) => {
    event && event.stopPropagation();
    setActiveTab(0);
    setCandidateDetailsLoading(true);
    setCandidateDetailsError("");
    const candidateId = candidate.id;
    const details = await fetchCandidateById(candidateId);
    if (!details) {
      setCandidateDetailsError(
        "Failed to load candidate details. Please try again later.",
      );
      setSelectedCandidate(null);
      return;
    } else {
      setSelectedCandidate(details);
    }
    setIsFromJobRecommendedCandidates(true);
    setIsCandidateDetailsOpen(true);
    setCandidateDetailsLoading(false);
  };

  const handleCloseCandidateDetails = () => {
    setIsCandidateDetailsOpen(false);
    setSelectedCandidate(null);
    setIsFromJobRecommendedCandidates(false);
    resetCandidateEdit();
  };

  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  useEffect(() => {
    if (!dropdownOpen) return;
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dropdownBtnRef.current &&
        !dropdownBtnRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const fetchVendors = async (query) => {
    try {
      setVendorOptionLoading(true);
      const res = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(query)}`,
      );
      setVendorList(
        (res.vendors || [])
          .filter((v) => v.id && v.name)
          .map((v) => ({
            label: v.contact_person
              ? `${v.name} - ${v.contact_person}`
              : v.name,
            value: v.id,
          })),
      );
    } catch {
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };
  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) fetchVendors(value);
    else setVendorList([]);
  };
  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidate?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidate?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }
    const candidateWithFormattedSkills = {
      ...selectedCandidate,
      name: selectedCandidate.name || selectedCandidate.BasicInfo?.Name || "",
      email:
        selectedCandidate.email || selectedCandidate.BasicInfo?.Email || "",
      secondaryEmail:
        selectedCandidate.secondaryEmail ||
        selectedCandidate.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidate.phone ||
        selectedCandidate.BasicInfo?.PhoneNumber ||
        "",
      secondaryPhone:
        selectedCandidate.secondaryPhone ||
        selectedCandidate.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidate.city ||
        selectedCandidate.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidate.state ||
        selectedCandidate.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidate.country ||
        selectedCandidate.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidate.skills)
        ? selectedCandidate.skills
        : selectedCandidate.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidate.vendorID ||
        selectedCandidate.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidate.designation?.trim() ||
        selectedCandidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
          ?.JobTitle ||
        "",
      experience: experienceValue,
      lineAddress1:
        selectedCandidate.lineAddress1 ||
        selectedCandidate.BasicInfo?.LineAddress1 ||
        "",
      lineAddress2:
        selectedCandidate.lineAddress2 ||
        selectedCandidate.BasicInfo?.LineAddress2 ||
        "",
      zipCode:
        selectedCandidate.zipCode || selectedCandidate.BasicInfo?.ZipCode || "",
      preferredSalary:
        selectedCandidate.preferredSalary ||
        selectedCandidate.BasicInfo?.PreferredSalary ||
        "",
    };
    setOriginalCandidateData({ ...selectedCandidate });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setEmailError("");
    setEmailTouched(false);
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setSelectedCandidate(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setEmailError("");
    setEmailTouched(false);
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => {
      const updated = {
        ...prev,
        ...data,
      };
      return updated;
    });
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      Toast("error", "No changes to save");
      return;
    }

    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidate.email || "";
    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }

    setEmailError("");
    setEmailTouched(false);

    try {
      const candidateData = { id: selectedCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidate[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          newValue !== ""
        ) {
          candidateData[key] = newValue;
        }
      });

      if (Object.keys(candidateData).length === 1) {
        Toast("error", "No changes to save");
        return;
      }
      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );

      if (response) {
        const updatedCandidate = {
          ...selectedCandidate,
          ...candidateData,
        };

        if (
          candidateData.vendorID !== undefined &&
          candidateData.vendorID !== selectedCandidate.vendorID
        ) {
          if (candidateData.vendorID) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidateData.vendorID}`,
              );
              updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
              setAssignedVendor(vendorResponse);
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
              setAssignedVendor(null);
            }
          } else {
            updatedCandidate.vendorDetails = null;
          }
        }

        setSelectedCandidate(updatedCandidate);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");

        setTasks((prevTasks) => {
          const newTasks = {};
          for (const stage in prevTasks) {
            newTasks[stage] = prevTasks[stage].map((c) =>
              c.id === updatedCandidate.id
                ? { ...c, name: updatedCandidate.name }
                : c,
            );
          }
          return newTasks;
        });

        if (isAllCandidatesActive) {
          setAllCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        } else {
          setMyCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        }
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  const fetchCallStages = async () => {
    try {
      const response = await get(
          VYLABS_BASE_URL,
          `${TENANTS_APPLICATION_STAGES_LIST}?active=true`,
          { headers: { "X-API-Key": TENANT_CORE_API_KEY } },
      );

      const stages = Array.isArray(response)
        ? response
        : response?.stages || [];
      setCallStages(stages);
    } catch (error) {
      console.error("Error fetching call stages:", error);
      setCallStages([]);
    }
  };

  const handleGetSavedViews = async () => {
    try {
      const savedViewRes = await getSavedViews();
      const isDefaultValue = savedViewRes?.views.find(i => i.isDefault);
      const response = isDefaultValue?.filters;
      setSavedCallStages(response || []);
      setAllSavedStages(savedViewRes?.views || []);
    }
    catch(error) {
      console.error("error in handleGetSavedViews", error);
      setSavedCallStages([]);
      setAllSavedStages([]);
    }
  }

  useEffect(() => {
    fetchCallStages();
    handleGetSavedViews();
  }, []);

  const handleCreateSaveView = async () => {
    try {
      if(visibleColumns.length === 0 ) {
        Toast("error", "Please select atleast one call stage to proceed.");
        return;
      }
      const filters = callStages.filter(item => visibleColumns.includes(item.system_key));
      const res = await createSavedViews(filters, "Application By Jobs Filter", true);
      if(res !== "") {
        handleGetSavedViews();
        setDropdownOpen(false);
      }
    }
    catch(error) {
      console.error("error in handleCreateSaveView", error);
    }
  };

  const handleUpdateSaveView = async () => {
    try {
      if(visibleColumns.length === 0 ) {
        Toast("error", "Please select atleast one call stage to proceed.");
        return;
      }
      const filters = callStages.filter(item => visibleColumns.includes(item.system_key));
      const id = (allSavedStages.find(item => item.isDefault));
      const savedId = id?.id;
      const res = await patchSavedViews(savedId, filters);
      if(res !== "") {
        handleGetSavedViews();
        setDropdownOpen(false);
      }
    }
    catch(error) {
      console.error("error in handleUpdateSaveView",error);
    }
  }

  return (
    <div>
      <div className="kanban-header">
        <div className="filter-container">
          <button
            className="column-visibility-btn"
            onClick={toggleDropdown}
            ref={dropdownBtnRef}
          >
            <img
              src={isDarkMode ? SettingsDarkIcon : SettingsIcon}
              alt="SettingsIcon"
              className="speedDial-popup-icon"
            />
            Customize
          </button>
          {dropdownOpen && (
            <div className="column-visibility-dropdown" ref={dropdownRef}>
              <div className="column-checkbox-item">
                <button
                  onClick={handleSelectAll}
                  className="view-button"
                  style={{
                    height: "36px",
                    width: "100px",
                    background: "#6860ee",
                    borderRadius: "8px",
                    cursor: "pointer",
                    padding: "8px 14px",
                    fontFamily: "Satoshi",
                    fontWeight: 600,
                    fontSize: "14px",
                    outline: "none",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    gap: 10,
                    border: "1px solid #6860EE",
                    color: "#FFFFFF",
                  }}
                >
                  Select All
                </button>
                <button
                  onClick={handleSelectNone}
                  className="view-button"
                  style={{
                    height: "36px",
                    width: "100px",
                    background: "var(--body__background)",
                    borderRadius: "8px",
                    cursor: "pointer",
                    padding: "8px 14px",
                    fontFamily: "Satoshi",
                    fontWeight: 600,
                    fontSize: "14px",
                    outline: "none",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    gap: 10,
                    border: "1px solid #6860EE",
                    color: "#6860EE",
                  }}
                >
                  Clear All
                </button>
              </div>
              {Object.entries(columnsForCustomize).map(([key, name]) => (
                <div key={key} className="column-checkbox-item">
                  <input
                    type="checkbox"
                    id={`column-${key}`}
                    checked={visibleColumns.includes(key)}
                    onChange={() => toggleColumnVisibility(key)}
                  />
                  <label htmlFor={`column-${key}`}>{toCapitalize(name)}</label>
                </div>
              ))}
              <div style={{ marginTop: "5px", display: "flex", justifyContent: "flex-end" }}>
                {savedCallStages.length === 0 ? (
                  <Button
                    label="Create saved view"
                    event={handleCreateSaveView}
                  />
                ) : (
                  <Button
                    label="Update saved view"
                    event={handleUpdateSaveView}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        autoScroll={{
          threshold: {
            x: 0.2,
            y: 0.2,
          },
          speed: {
            x: 10,
            y: 10,
          },
          interval: 10,
        }}
        modifiers={[snapCenterToCursor]}
        onDragOver={(event) => {
          const { over } = event;
          if (over) {
            const columns = document.querySelectorAll(".kanban-column");
            columns.forEach((column) => {
              column.classList.remove("column-highlight");
            });

            let columnToHighlight;

            if (typeof over.id === "string") {
              const directColumn = document.querySelector(
                `.kanban-column[data-column-id="${over.id}"]`,
              );
              if (directColumn) {
                columnToHighlight = directColumn;
              }
            }

            if (!columnToHighlight) {
              const fromColumn = Object.keys(tasks).find((col) =>
                (tasks[col] || []).filter(Boolean).includes(over.id),
              );

              if (fromColumn) {
                const columnElement = document.querySelector(
                  `.kanban-column[data-column-id="${fromColumn}"]`,
                );
                if (columnElement) {
                  columnToHighlight = columnElement;
                }
              }
            }

            if (columnToHighlight) {
              columnToHighlight.classList.add("column-highlight");
            }
          }
        }}
      >
        <div className="kanban-scroll-synced">
          <div className="kanban-scroll-top" ref={topScrollRef}>
            <div
              className="kanban-scroll-top-inner"
              style={{ width: `${totalWidth}px` }}
            />
          </div>

          <div className="kanban-scroll-bottom" ref={bottomScrollRef}>
            <div className="kanban-container">
              {Object.keys(tasks).length === 0 ? (
                <div className="empty-state">
                  <div className="empty-state-content">
                    <div style={{ marginTop: "40px" }}>
                      <VybogTALLoaderAnimation />
                    </div>
                  </div>
                </div>
              ) : (
                Object.entries(columns)
                  .map(([key, name]) => (
                    <div
                      key={key}
                      className={`kanban-column${
                        tasks[key] && tasks[key].length > 0 ? " has-cards" : ""
                      }`}
                      data-column-id={key}
                    >
                      <div
                        className={`column-header${
                          tasks[key] && tasks[key].length > 0
                            ? " has-cards"
                            : ""
                        }`}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            minWidth: 0,
                          }}
                        >
                          {isSelectMode && (stageCounts[key] || 0) > 0 && (
                            <div
                              role="button"
                              tabIndex={0}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleStageSelection(key);
                              }}
                              onPointerDown={(e) => e.stopPropagation()}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  toggleStageSelection(key);
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor:
                                  (tasks[key] || []).filter(Boolean).length > 0
                                    ? "pointer"
                                    : "default",
                                flexShrink: 0,
                              }}
                              aria-label={
                                isStageSelected(key)
                                  ? `Deselect all candidates in ${name}`
                                  : `Select all candidates in ${name}`
                              }
                            >
                              {isStageSelected(key) ? (
                                <CheckBoxIcon style={{ color: "#6860ee" }} />
                              ) : (
                                <CheckBoxOutlineBlankIcon
                                  style={{ color: "var(--header__color)" }}
                                />
                              )}
                            </div>
                          )}
                          <h4 className="column-title">{toCapitalize(name)}</h4>
                        </div>
                        <span
                          className={`column-count ${getColumnCountClass(
                            name,
                          )}`}
                        >
                          {stageCounts[key] || 0}
                        </span>
                      </div>
                      <div
                        className="column-card-container"
                        style={{
                          height: "calc(100vh - 310px)",
                          overflowY: "auto",
                          paddingRight: "5px",
                        }}
                      >
                        <SortableContext
                          key={tasks[key]}
                          id={tasks[key]}
                          items={tasks[key]}
                          strategy={verticalListSortingStrategy}
                        >
                          {tasks[key].length === 0 ? (
                            <SortableItem
                              key={key}
                              id={key}
                              candidate={tasks[key]}
                              columnKey={name}
                              onCandidateClick={onCandidateClick}
                              onView={handleCardView}
                              isSelectMode={isSelectMode}
                              onSelectCandidate={onSelectCandidate}
                              selectedCandidates={selectedCandidates}
                            />
                          ) : (
                            tasks[key].map((task, index) => (
                              <SortableItem
                                key={index}
                                id={task}
                                candidate={task}
                                columnKey={name}
                                onCandidateClick={onCandidateClick}
                                onView={handleCardView}
                                isSelectMode={isSelectMode}
                                onSelectCandidate={onSelectCandidate}
                                selectedCandidates={selectedCandidates}
                              />
                            ))
                          )}
                        </SortableContext>
                      </div>
                    </div>
                  ))
              )}
            </div>
          </div>
        </div>

        <DragOverlay
          adjustScale={false}
          zIndex={9999}
          dropAnimation={{
            duration: 300,
            easing: "cubic-bezier(0.18, 0.67, 0.6, 1.22)",
            scale: 0.98,
          }}
        >
          {activeId ? (
            <div
              className={`candidate-card`}
              style={{
                opacity: 1,
                backgroundColor: "var(--body__background)",
                borderRadius: "20px",
                boxShadow:
                  "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
                zIndex: 9999,
                pointerEvents: "none",
                width: "220px",
                transform: "scale(1.05)",
                visibility: "visible !important",
              }}
            >
              {Object.entries(tasks).map(([colKey, candidates]) => {
                const candidate = candidates.find((c) => c === activeId);
                if (candidate) {
                  return (
                    <CandidateCard
                      key="overlay-card"
                      candidate={candidate}
                      onClick={() => {}}
                      onView={handleCardView}
                    />
                  );
                }
                return null;
              })}
            </div>
          ) : null}
        </DragOverlay>
      </DndContext>

      <ConfirmationPopup
        isOpen={confirmationOpen}
        onClose={handleCancelStageChange}
        onConfirm={handleConfirmStageChange}
        title="Update Candidate Stage"
        message={
          dragData
            ? `Do you want to update this candidate's stage to "${
                columns[dragData.toColumn]
              }"?`
            : ""
        }
        confirmLabel="Yes, Update"
        cancelLabel="Cancel"
      />

      {isCandidateDetailsOpen && (
        <SidePopup
          isOpen={isCandidateDetailsOpen}
          onClose={handleCloseCandidateDetails}
          title="Candidate Details"
          sidePopupWidth="85%"
        >
          {candidateDetailsLoading ? (
            <div style={{ padding: 40, textAlign: "center" }}>Loading...</div>
          ) : candidateDetailsError ? (
            <div style={{ padding: 40, textAlign: "center", color: "#d32f2f" }}>
              {candidateDetailsError}
            </div>
          ) : selectedCandidate ? (
            <div className="candidate-details-wrapper">
              <CandidateDetailsContainer
                candidate={selectedCandidate}
                activeTab={activeTab}
                handleTabChange={handleTabChange}
                isEditingCandidate={isEditingCandidate}
                handleEditCandidate={handleEditCandidate}
                saveCandidateChanges={saveCandidateChanges}
                resetCandidateEdit={resetCandidateEdit}
                handleCandidateChange={handleCandidateChange}
                editedCandidateData={editedCandidateData}
                vendorList={vendorList}
                vendorOptionLoading={vendorOptionLoading}
                handleVendorInputChange={handleVendorInputChange}
                assignedVendor={assignedVendor}
                showCandidateInterviewTab={false}
                showCandidateRecommendedJobsTab={false}
              />
            </div>
          ) : (
            <div style={{ padding: 40, textAlign: "center" }}>
              No candidate selected.
            </div>
          )}
        </SidePopup>
      )}
    </div>
  );
}

export default KanbanBoard;